import { createDynamicSlice } from ".";
import { fetchSendFormsThunk } from "../thunks/sendFormsThunk";

export const sendFormsSlice = createDynamicSlice({
  name: "sendForms",
  thunk: fetchSendFormsThunk,
  listMode: true,
  resetActionName: "resetSendForms",
});

export const sendFormsReducer = sendFormsSlice.reducer;
export const { resetSendForms } = sendFormsSlice.actions;
